import { ReactElement, useEffect, useState } from "react";
import * as THREE from "three";
import "./index.css";
import {
  load3dAnimation,
  loadPearlVideo,
  loadSilverGVideo,
} from "./rewardAnimationLoader";

let camera: any, scene: any, renderer: any, mixer: any;
const clock = new THREE.Clock();
const animationActions: any[] = [];
const waitings = new Set();
let animType: any = "3d";

interface IProps {
  id?: number;
  coin?: number;
  addCoin: "Silver" | "Pearl" | "Gold";
  onClickNextEx: () => void;
}

function getViewportSize() {
  return {
    width: window.innerWidth,
    height: window.innerHeight,
  };
}

function disposeRewardRenderer() {
  if (renderer) {
    renderer.setAnimationLoop(null);
    const el = renderer.domElement;
    if (el?.parentNode) {
      el.parentNode.removeChild(el);
    }
    renderer.dispose();
    renderer = null;
  }
  if (mixer) {
    mixer.stopAllAction();
    mixer = null;
  }
  animationActions.length = 0;
  waitings.clear();
  scene = null;
  camera = null;
}

function lockPageScroll() {
  const scrollY = window.scrollY;
  const prev = {
    htmlOverflow: document.documentElement.style.overflow,
    bodyOverflow: document.body.style.overflow,
    bodyPosition: document.body.style.position,
    bodyTop: document.body.style.top,
    bodyWidth: document.body.style.width,
  };
  document.documentElement.style.overflow = "hidden";
  document.body.style.overflow = "hidden";
  document.body.style.position = "fixed";
  document.body.style.top = `-${scrollY}px`;
  document.body.style.width = "100%";
  return () => {
    document.documentElement.style.overflow = prev.htmlOverflow;
    document.body.style.overflow = prev.bodyOverflow;
    document.body.style.position = prev.bodyPosition;
    document.body.style.top = prev.bodyTop;
    document.body.style.width = prev.bodyWidth;
    window.scrollTo(0, scrollY);
  };
}

export function RewardLesson(props: IProps): ReactElement {
  const [hide_button, set_hide_button] = useState<boolean>(true);
  let monetType = "серебряных монет";
  let video_modificator = "";
  switch (props.addCoin) {
    case "Pearl":
      monetType = "жемчуг";
      video_modificator = "_video_gold";
      break;
    case "Gold":
      monetType = "золотую монету";
      video_modificator = "_video_gold";
      break;
  }

  useEffect(() => {
    return lockPageScroll();
  }, []);

  useEffect(() => {
    const host = document.createElement("div");
    host.className = "glanimation" + video_modificator;
    document.body.appendChild(host);

    let cancelled = false;
    const onPause = () => {
      if (!cancelled) set_hide_button(false);
    };

    switch (props.addCoin) {
      case "Pearl":
        startVideoPearl(host, onPause);
        break;
      case "Gold":
        startSilverGVideo(host, onPause);
        break;
      default:
        init(host, onPause);
        break;
    }

    return () => {
      cancelled = true;
      disposeRewardRenderer();
      host.querySelectorAll("*").forEach((node) => node.remove());
      host.remove();
    };
  }, [props.addCoin, video_modificator]);

  const clck = () => {
    continueAnim();
    set_hide_button(true);
    setTimeout(() => {
      props.onClickNextEx();
    }, 3000);
  };

  return (
    <div className="rewardConteinerFlexConteiner">
      <div className="rewardConteiner">
        <div className="rewardConteiner-Mess">
          <p className="rewardConteiner-cauntCoinText">
            Вы получили {props.coin}
          </p>
          <p className="rewardConteiner-cauntCoinText">{monetType}</p>
        </div>
        <div
          className="lessonPageReward-button"
          onClick={clck}
          style={{ visibility: hide_button ? "hidden" : undefined }}
        >
          Спасибо!
        </div>
      </div>
    </div>
  );
}

async function init(container: HTMLElement, onPause: () => void) {
  disposeRewardRenderer();

  const { width, height } = getViewportSize();
  camera = new THREE.PerspectiveCamera(45, width / height, 0.25, 20);
  camera.position.set(-1.8, 0.6, 2.7);

  scene = new THREE.Scene();
  load3dAnimation().then((r) => {
    start(r, onPause);
  });
  renderer = new THREE.WebGLRenderer({
    antialias: true,
    preserveDrawingBuffer: true,
    alpha: true,
  });
  animType = "3d";
  renderer.setPixelRatio(window.devicePixelRatio);
  renderer.setSize(width, height);
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  renderer.toneMappingExposure = 1;
  renderer.setAnimationLoop(render);
  container.appendChild(renderer.domElement);
}

function start_animation(anim_action: any) {
  anim_action.reset();
  waitings.add(anim_action);
  anim_action.play();
}

function render() {
  const delta = clock.getDelta();

  if (mixer) mixer.update(delta);
  if (renderer && scene && camera) {
    renderer.render(scene, camera);
  }
}

function startVideoPearl(container: HTMLElement, onPause: () => void) {
  loadPearlVideo().then((r) => {
    const video = document.createElement("video");
    video.setAttributeNS(null, "width", "1125");
    video.setAttributeNS(null, "height", "2436");
    video.src = r;
    const can = document.createElement("canvas");
    can.setAttributeNS(null, "width", "1125");
    can.setAttributeNS(null, "height", "2436");
    container.querySelectorAll("*").forEach((n) => n.remove());
    container.append(can);

    container.append(video);
    const proc = new Processor(video, can);
    proc.doLoad();
    video.play();
    animType = video;
    setTimeout(() => {
      video.pause();
      onPause();
    }, 4500);
  });
}

function startSilverGVideo(container: HTMLDivElement, onPause: () => void) {
  loadSilverGVideo().then((r) => {
    const video = document.createElement("video");
    video.setAttributeNS(null, "width", "1125");
    video.setAttributeNS(null, "height", "2436");
    video.src = r;
    const can = document.createElement("canvas");
    can.setAttributeNS(null, "width", "1125");
    can.setAttributeNS(null, "height", "2436");
    container.querySelectorAll("*").forEach((n) => n.remove());
    container.append(can);

    container.append(video);
    const proc = new Processor(video, can);
    proc.doLoad();
    video.play();
    animType = video;
    setTimeout(() => {
      video.pause();
      onPause();
    }, 4500);
  });
}

class Processor {
  video: HTMLVideoElement;
  canvas: HTMLCanvasElement;
  ctx: CanvasRenderingContext2D;
  width: number;
  height: number;
  constructor(video: HTMLVideoElement, canvas: HTMLCanvasElement) {
    this.video = video;
    this.canvas = canvas;
    this.ctx = this.canvas.getContext("2d") as CanvasRenderingContext2D;
    this.width = +this.video.width;
    this.height = +this.video.height;
  }
  timerCallback() {
    if (this.video.paused || this.video.ended) {
      return;
    }
    this.computeFrame();
    const self = this;
    setTimeout(function () {
      self.timerCallback();
    }, 0);
  }

  doLoad() {
    this.video.addEventListener(
      "play",
      () => {
        this.width = +this.video.width;
        this.height = +this.video.height;
        this.timerCallback();
      },
      false
    );
  }

  computeFrame() {
    this.ctx.drawImage(this.video, 0, 0, this.width, this.height);
  }
}

async function start({ gltf, texture }: any, onPause: () => void) {
  if (!renderer || !scene) return;

  scene.environment = texture;
  const model = gltf.scene;
  await renderer.compileAsync(model, camera, scene);
  mixer = new THREE.AnimationMixer(gltf.scene);

  for (const anim of gltf.animations) {
    const action = mixer.clipAction(anim);
    action.setLoop(THREE.LoopOnce);
    animationActions.push(action);
  }
  animationActions.forEach(start_animation);
  camera = gltf.cameras[0];
  camera.position.x = -17;
  camera.position.y = 3.5;
  //@ts-ignore
  window._camera = camera;

  setTimeout(() => {
    animationActions.forEach((a) => (a.paused = true));
    onPause();
  }, 5650);
  const { width, height } = getViewportSize();
  camera.aspect = width / height;
  camera.updateProjectionMatrix();
  scene.add(model);
}

function continueAnim() {
  if (animType === "3d") animationActions.forEach((a) => (a.paused = false));
  else animType.play();
}
